import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import type { CutSaveState } from '../doc/useCutAutosave';
import { editorMessages } from '../messages/editorMessages';
import { SAVE_STATE_MESSAGES } from './saveStateMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The save state of the top bar (design b1: "Saved"). It is a live region. */
const SaveStateComponent: React.FC<{ state: CutSaveState; readOnly: boolean }> = ({ state, readOnly }) => {
  const intl = useIntl();
  return (
    <span
      className={clsx(
        styles.saved,
        state !== 'saved' && styles.savedDirty,
        (state === 'failed' || state === 'invalid') && styles.savedFailed
      )}
      role="status"
    >
      <i />
      {intl.formatMessage(readOnly ? editorMessages.saveReadOnly : SAVE_STATE_MESSAGES[state])}
    </span>
  );
};

export const SaveState = TypedMemo(SaveStateComponent);
